import { Formula } from '../../../../lib/types/models/formula/formula'
import { FormulaInput } from '../../../../lib/types/models/formula/formula-input'

export const mapFormulaToInput = (data: Formula): FormulaInput => {
  return {
    code: data.code,
    description: data.description,
    category: data.category,
    displayLongVersionForClientSpace: data.displayLongVersionForClientSpace,
    translations: data.translations ?? []
  }
}
